<navigation [backEnabled]="false"></navigation>
<div class="wrapper">
  <div class="container">
    <div class="row">
      <div class="col-xs-12 offset-md-2 col-md-8 offset-lg-3 col-lg-6">
        <div class="card">
          <h2>{{ "Global.NoAccess" | translate }}</h2>
          @switch (auth.authenticationCase()) {
            @case ("NoRoles") {
              <p>{{ "Page.Forbidden.NoRoles.Description" | translate }}</p>
            }
            @case ("NoIcp") {
              <p>{{ "Page.Forbidden.NoIcp.Description" | translate }}</p>
            }
            @case ("NoCustomer") {
              <p>{{ "Page.Forbidden.NoCustomer.Description" | translate }}</p>
            }
            @default {
              <p>{{ "Page.Forbidden.Description" | translate }}</p>
            }
          }
        </div>
      </div>
    </div>
  </div>
  <div class="container"><footer></footer></div>
</div>
